import React, { useState } from 'react';
import { COLORS } from '../../../core/constants/colors';

interface PasswordInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  value,
  onChange,
  error,
  placeholder,
  required = false,
  disabled = false,
  onMouseEnter,
  onMouseLeave,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="mb-4 w-full">
      <label
        className="block text-sm font-medium mb-2"
        style={{ color: COLORS.primary.persianIndigo }}
      >
        {label} {required && <span style={{ color: COLORS.extended.redSalsa }}>*</span>}
      </label>
      <div className="relative">
        <input
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className="w-full px-4 py-3 pr-12 rounded-lg border-2 focus:outline-none focus:ring-2 transition-all disabled:opacity-60"
          style={{
            borderColor: error ? COLORS.extended.redSalsa : 'transparent',
            backgroundColor: '#F2F2F2',
            color: COLORS.primary.persianIndigo,
          }}
          onFocus={(e) => {
            if (!error) {
              e.target.style.borderColor = COLORS.user.queryButton;
            }
          }}
          onBlur={(e) => {
            if (!error) {
              e.target.style.borderColor = 'transparent';
            }
          }}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 focus:outline-none"
          style={{ color: COLORS.primary.persianIndigo }}
          tabIndex={-1}
        >
          {showPassword ? (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
              />
            </svg>
          ) : (
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          )}
        </button>
      </div>
      {error && (
        <p className="text-sm mt-1" style={{ color: COLORS.extended.redSalsa }}>
          {error}
        </p>
      )}
    </div>
  );
};

